export default "__VITE_ASSET___SA6pEqx__"